import UserInfoTab from './UserInfoTab'

export default UserInfoTab
